/* eslint-disable no-unused-vars */
import { useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../assets/images/svgs/edit.svg";
import { ReactComponent as Trash } from "../../../../assets/images/svgs/trash.svg";
import DataTable from "../../../../components/dataTable/dataTable";
import EditKyc from "../../../../components/modals/EditKycModal";
import ProductModal from "../../../../components/modals/ProductModal";
import { getKycRules } from "../../../../store/actions/compliance.action";
import { kycTableConfig } from "../../../../utils/helpers/dataTableConfigs";
import { deleteKycRule } from "../../../../utils/services/compliance.service";
import AddNewKYC from "./atom/AddNewKYC";

const Body = ({ domainBrand, rules, countries }) => {
  const dispatch = useDispatch();
  const [addNewState, updateState] = useState(false);
  const [type, setType] = useState("");
  const [show, setShow] = useState(false);
  const [kyc, setKyc] = useState("");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [kycObject, setKycObject] = useState({});
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );

  const actionColumn = {
    Header: () => {
      return <span className="text-center">Action</span>;
    },
    columnId: 7,
    accessor: "actions",
    Cell: ({ row }) => {
      return (
        <div className="text-center pointer">
          <OverlayTrigger
            key={"1"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Edit</Tooltip>}
          >
            <Edit
              onClick={() => {
                setOpen(true);
                setId(row?.original?.id);
                setKycObject(row?.original);
              }}
            />
          </OverlayTrigger>

          <OverlayTrigger
            key={"2"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Delete</Tooltip>}
          >
            <Trash
              onClick={() => {
                setShow(true);
                setType("KYC-DELETE");
                setKyc(row?.original?.businessRuleNumber);
                setId(row?.original?.id);
              }}
            />
          </OverlayTrigger>
        </div>
      );
    },
  };

  const kycTable = kycTableConfig(languageStatus, dictionary);
  const tableObject = [...kycTable, actionColumn];

  const columns = useMemo(() => tableObject, []);
  const addNewStatus = (event) => {
    event.preventDefault();
    updateState(!addNewState);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const res = await deleteKycRule(id);
      if (res?.data?.status === "SUCCESS") {
        toast.success("kyc deleted successfully");
        setLoading(false);
        setShow(false);
        dispatch(getKycRules());
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <ProductModal
        show={show}
        handleClose={() => setShow(false)}
        type={type}
        handleDeleteKyc={() => handleDelete(id)}
        kyc={kyc}
        loading={loading}
      />
      <EditKyc
        show={open}
        handleClose={() => setOpen(false)}
        languageStatus={languageStatus}
        dictionary={dictionary}
        countries={countries}
        id={id}
        kycObject={kycObject}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {languageStatus
                  ? dictionary["WO_KNOW_YOUR_CUSTOMERS_829353076"]
                  : "Know Your Customers (KYC) Rules"}
              </h1>
            </div>
            <div className="ms-auto pageheader-btn">
              {/* <NavLink
                onClick={addNewStatus}
                to="/"
                className="btn btn-primary btn-icon text-white me-2"
              >
                <span>
                  <i className="fa fa-folder-plus" />
                </span>{" "}
                &nbsp;
                {languageStatus ? dictionary["button_add_new"] : "Add New"}
              </NavLink> */}
            </div>
          </div>
          <>
            <div className="row row-sm">
              {/* {addNewState ? (
                <div className="col-lg-12">
                  <div className="card overflow-hidden">
                    <div className="card-header bg-primary text-white">
                      <h3 className="card-title">
                        {languageStatus
                          ? dictionary["button_add_new"]
                          : "Add New"}
                      </h3>
                    </div>
                    <AddNewKYC
                      languageStatus={languageStatus}
                      dictionary={dictionary}
                      countries={countries}
                    />
                  </div>
                </div>
              ) : (
                ""
              )} */}
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div className="card-header bg-primary text-white">
                    <h3 className="card-title">
                      {languageStatus
                        ? dictionary["button_add_new"]
                        : "Add New"}
                    </h3>
                  </div>
                  <AddNewKYC
                    languageStatus={languageStatus}
                    dictionary={dictionary}
                    countries={countries}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div className="card-header bg-primary text-white">
                    <h3 className="card-title">
                      {languageStatus
                        ? dictionary["KYCKNOW_YOUR_CUSTOM_723094592"]
                        : "KYC(know your customer) rules"}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div>
                      <p className="text-muted card-sub-title">
                        {languageStatus
                          ? dictionary["WO_SORT_AND_FILTER_TABL_1070504595"]
                          : " Sort and filter table"}
                      </p>
                    </div>
                    <div className="table-responsive">
                      <DataTable columns={columns} data={rules.kycRules} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Body;
